const InfoCard = () => {
  return (
    <div className="bg-white rounded-lg border border-slate-200 shadow-sm p-4">
      <div className="flex items-center gap-1.5 mb-2">
        <i className="ri-information-line text-amber-600 text-xs" />
        <h4 className="text-xs font-semibold text-slate-700">계정 관리 기준</h4>
      </div>
      <p className="text-xs text-slate-500 leading-relaxed" style={{ wordBreak: "keep-all" }}>
        이 화면은 USER_ACCOUNT 기준 Senior·Keeper 로그인 계정만 표시합니다. Senior 통합 정보는 Senior 관리에서, Keeper-Senior 관계는 가족 연결에서 확인합니다. 관리자 운영계정은 별도 API가 필요합니다.
      </p>
    </div>
  );
};

export default InfoCard;
